import React from 'react'
import { Box, Chip, Stack, Typography } from '@mui/material'
import { getStateTransitionColor, getStateTransitionLabel } from 'utils/projectHourComments'

export type ProjectHourComment = {
  id: number
  created: string
  author: { id: number; username: string } | null
  state_transition: string
  text: string
}

type ProjectHourCommentsProps = {
  comments: ProjectHourComment[]
}

const formatCreated = (created: string): string => {
  const date = new Date(created)
  if (Number.isNaN(date.getTime())) {
    return created
  }
  return date.toLocaleString('nl-NL', { dateStyle: 'short', timeStyle: 'short' })
}

const capitalize = (value: string): string => value.charAt(0).toUpperCase() + value.slice(1)

const ProjectHourComments: React.FC<ProjectHourCommentsProps> = ({ comments }) => {
  if (!comments.length) {
    return null
  }

  return (
    <Stack spacing="12px">
      <Typography variant="h2">Eerdere toelichtingen</Typography>
      {comments.map((comment) => {
        const label = getStateTransitionLabel(comment.state_transition)
        const color = getStateTransitionColor(comment.state_transition)

        return (
          <Box key={comment.id} sx={{ borderLeft: '2px solid rgba(0, 0, 0, 0.12)', paddingLeft: '10px' }}>
            <Stack direction="row" spacing="8px" alignItems="center">
              <Typography variant="body1" fontWeight="bold">
                {comment.author?.username ?? 'Onbekend'}
              </Typography>
              {label && color && (
                <Chip
                  label={capitalize(label)}
                  color={color}
                  sx={{
                    fontWeight: 'bold',
                    padding: 0,
                    fontSize: '12px',
                    minHeight: '27px',
                    height: '27px',
                    lineHeight: '17px',
                    '& .MuiChip-label': { padding: '0 6px' },
                  }}
                />
              )}
            </Stack>
            <Typography variant="caption">{formatCreated(comment.created)}</Typography>
            <Typography variant="body2">{comment.text}</Typography>
          </Box>
        )
      })}
    </Stack>
  )
}

export default ProjectHourComments
